import classNames from 'classnames/bind';

import s from './Message.module.scss';

const c = classNames.bind(s);

export const Message = ({
  children,
  id,
  error = true,
  className,
  inline = true,
}: {
  children: React.ReactNode;
  id: string;
  error?: boolean;
  className?: string;
  inline?: boolean;
}) => {
  if (!children) {
    return null;
  }

  return (
    <div id={id} className={c(s.message, className, { inline, error })}>
      {children}
    </div>
  );
};
